import { t } from "@/i18n-js/instance";
import type { IconType } from "@/react/components/shared/Icon";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@/react/components/shared/uikit/Typography";
import type { Template } from "../../generated/WorkflowsApi.types";

type TemplateType = Template["template_type"];

const localeNamespace = "settings.workflows.templates";

const TEMPLATE_TYPE_ICONS: Record<TemplateType, IconType> = {
  dynamic: "12-zap",
  bulk_action: "12-layers",
  scheduled: "12-layers",
};

interface WorkflowTemplateTypePillProps {
  templateType: TemplateType;
}

export const WorkflowTemplateTypePill = ({
  templateType,
}: WorkflowTemplateTypePillProps) => {
  if (!templateType) {
    return null;
  }

  return (
    <span className="bg-tertiary inline-flex items-center gap-1 rounded-full px-2 py-1">
      <Icon
        type={TEMPLATE_TYPE_ICONS[templateType]}
        size={12}
        className="text-dark !size-[12px]"
      />
      <Typography.LabelXxs weight="medium" textTransform="capitalize">
        {t([localeNamespace, templateType])}
      </Typography.LabelXxs>
    </span>
  );
};
